import { useIncomingInvoicePermissions } from "components/incomingInvoice";

function useSupplierPermissions() {
  const { canViewIncomingInvoices } = useIncomingInvoicePermissions();

  return {
    canViewSuppliers: canViewIncomingInvoices,
  };
}

export default useSupplierPermissions;
